import React, { useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Image,
  Form,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../actions/cartActions";

const CartScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  let { id } = useParams();
  const productId = id;

  //console.log(location.search); //?qty=3
  const qty = location.search ? Number(location.search.split("=")[1]) : 1;

  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const userLogin = useSelector((state) => state.userLogin);
  const { cartItems } = cart;
  const { userInfo } = userLogin;
  //console.log(cartItems);

  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, qty)); //cartActions.js
    }
  }, [dispatch, productId, qty]);

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    navigate("/shipping");
  };
  const LoginHandler = () => {
    navigate("/login");
  };

  // Pre-compute totals so the JSX stays clean.
  const totalQty = cartItems.reduce((acc, item) => acc + item.qty, 0);
  const totalPrice = cartItems
    .reduce((acc, item) => acc + item.qty * item.price, 0)
    .toFixed(2);

  return (
    <div className="hadacy-cart">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

        /* ─── HADACY · cart ───
           Same palette + variable handoff as the other panels so a
           dark-mode pass picks it up automatically. */
        .hadacy-cart {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          --card-bg: #faf7f2;
          --recess: #efe7d8;
          --hairline: rgba(184, 147, 58, 0.18);
          font-family: "Jost", sans-serif;
          color: var(--dark);
        }
        .hadacy-cart__heading {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.04em;
          color: var(--dark);
          font-size: 1.9rem;
          margin: 0 0 1.3rem 0;
          position: relative;
          padding-bottom: 0.55rem;
          text-transform: capitalize;
        }
        .hadacy-cart__heading::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 48px;
          height: 1px;
          background: var(--gold);
        }

        /* ── Empty state ── */
        .hadacy-cart-empty {
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 14px;
          padding: 2.5rem 1.5rem;
          text-align: center;
          color: var(--muted);
        }
        .hadacy-cart-empty i {
          font-size: 2rem;
          color: var(--gold);
          opacity: 0.6;
          margin-bottom: 0.9rem;
        }
        .hadacy-cart-empty h3 {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          font-size: 1.4rem;
          color: var(--dark);
          margin: 0 0 0.3rem 0;
        }
        .hadacy-cart-empty p {
          font-size: 0.88rem;
          margin: 0 0 1.2rem 0;
        }
        .hadacy-cart-empty__cta {
          display: inline-block;
          padding: 0.65rem 1.4rem;
          border-radius: 999px;
          background: var(--dark);
          color: var(--gold-light) !important;
          font-size: 0.68rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          text-decoration: none !important;
          transition: background .2s ease, color .2s ease;
        }
        .hadacy-cart-empty__cta:hover {
          background: var(--gold);
          color: var(--dark) !important;
        }

        /* ── Line items ── */
        .hadacy-cart-list {
          display: flex;
          flex-direction: column;
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 14px;
          overflow: hidden;
        }
        .hadacy-cart-row {
          display: grid;
          grid-template-columns: 96px 1fr auto auto auto;
          gap: 1.1rem;
          align-items: center;
          padding: 1rem 1.15rem;
        }
        .hadacy-cart-row + .hadacy-cart-row {
          border-top: 1px solid var(--hairline);
        }
        .hadacy-cart-row__img {
          width: 96px;
          height: 96px;
          border-radius: 12px;
          overflow: hidden;
          background: var(--recess);
          display: block;
        }
        .hadacy-cart-row__img img {
          width: 100%; height: 100%;
          object-fit: cover;
        }
        .hadacy-cart-row__info { min-width: 0; }
        .hadacy-cart-row__kicker {
          font-size: 0.6rem;
          letter-spacing: 0.22em;
          color: var(--gold);
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        .hadacy-cart-row__name {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          font-size: 1.25rem;
          color: var(--dark) !important;
          text-decoration: none !important;
          line-height: 1.2;
        }
        .hadacy-cart-row__name:hover { color: var(--gold) !important; }
        .hadacy-cart-row__inspo {
          font-style: italic;
          font-size: 0.82rem;
          color: var(--muted);
          margin-top: 0.2rem;
          line-height: 1.35;
        }
        .hadacy-cart-row__price {
          font-family: "Cormorant Garamond", serif;
          font-size: 1.2rem;
          color: var(--dark);
          letter-spacing: 0.02em;
          white-space: nowrap;
          min-width: 4.5rem;
          text-align: right;
        }
        .hadacy-cart-row__qty {
          background: #fff !important;
          border: 1px solid rgba(184, 147, 58, 0.28) !important;
          border-radius: 999px !important;
          padding: 0.4rem 2rem 0.4rem 1rem !important;
          font-family: "Jost", sans-serif;
          font-size: 0.88rem;
          color: var(--dark) !important;
          box-shadow: none !important;
          min-width: 70px;
          background-image: linear-gradient(45deg, transparent 50%, var(--gold) 50%),
                            linear-gradient(135deg, var(--gold) 50%, transparent 50%) !important;
          background-position: calc(100% - 18px) center, calc(100% - 12px) center !important;
          background-size: 6px 6px, 6px 6px !important;
          background-repeat: no-repeat !important;
        }
        .hadacy-cart-row__qty:focus {
          border-color: var(--gold) !important;
          box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14) !important;
        }
        .hadacy-cart-row__remove {
          width: 38px;
          height: 38px;
          border-radius: 999px;
          border: 1px solid rgba(184, 147, 58, 0.22);
          background: transparent;
          color: var(--muted);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background .2s ease, color .2s ease, border-color .2s ease;
        }
        .hadacy-cart-row__remove:hover {
          background: rgba(184, 147, 58, 0.1);
          color: var(--gold);
          border-color: var(--gold);
        }
        .hadacy-cart-row__remove i { font-size: 0.85rem; }

        /* ── "Seguir comprando" link ── */
        .hadacy-cart-continue {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          margin-top: 1.4rem;
          font-size: 0.78rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--muted) !important;
          text-decoration: none !important;
          transition: color .2s ease, gap .2s ease;
        }
        .hadacy-cart-continue:hover {
          color: var(--gold) !important;
          gap: 0.7rem;
        }
        .hadacy-cart-continue i { font-size: 0.7rem; }

        /* ── Right-hand summary ── */
        .hadacy-cart-summary {
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 14px;
          padding: 1.4rem 1.4rem 1.5rem;
          position: sticky;
          top: 1rem;
        }
        .hadacy-cart-summary__title {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.04em;
          font-size: 1.4rem;
          color: var(--dark);
          margin: 0 0 0.25rem 0;
        }
        .hadacy-cart-summary__count {
          font-size: 0.7rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
        }
        .hadacy-cart-summary__rule {
          height: 1px;
          background: var(--hairline);
          margin: 1rem 0;
        }
        .hadacy-cart-summary__row {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 0.5rem;
          font-size: 0.92rem;
        }
        .hadacy-cart-summary__row span:first-child { color: var(--muted); }
        .hadacy-cart-summary__total {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          padding-top: 0.4rem;
        }
        .hadacy-cart-summary__total .hcs-label {
          font-size: 0.72rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
        }
        .hadacy-cart-summary__total .hcs-amount {
          font-family: "Cormorant Garamond", serif;
          font-size: 1.7rem;
          color: var(--dark);
          letter-spacing: 0.02em;
        }
        .hadacy-cart-summary__cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          gap: 0.55rem;
          margin-top: 1.1rem;
          padding: 0.85rem 1.5rem;
          border-radius: 999px;
          background: var(--dark);
          border: 1px solid var(--dark);
          color: var(--gold-light);
          font-size: 0.7rem;
          font-weight: 400;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: background .2s ease, color .2s ease, opacity .2s ease;
        }
        .hadacy-cart-summary__cta:hover:not(:disabled) {
          background: var(--gold);
          border-color: var(--gold);
          color: var(--dark);
        }
        .hadacy-cart-summary__cta:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }
        .hadacy-cart-summary__cta i { font-size: 0.8rem; }
        .hadacy-cart-summary__hint {
          font-size: 0.78rem;
          color: var(--muted);
          margin-top: 0.7rem;
          text-align: center;
        }
        .hadacy-cart-summary__hint--warn { color: #a94139; }

        /* ── Mobile: stack and refit ── */
        @media (max-width: 575.98px) {
          .hadacy-cart-row {
            grid-template-columns: 72px 1fr auto;
            grid-template-areas:
              "img info remove"
              "img price qty";
            gap: 0.6rem 0.85rem;
          }
          .hadacy-cart-row__img { grid-area: img; width: 72px; height: 72px; }
          .hadacy-cart-row__info { grid-area: info; }
          .hadacy-cart-row__price { grid-area: price; text-align: left; }
          .hadacy-cart-row__qty { grid-area: qty; min-width: 64px; }
          .hadacy-cart-row__remove { grid-area: remove; }
          .hadacy-cart-summary { position: static; }
        }
      `}</style>

      <Row>
        <Col md={8}>
          <h1 className="hadacy-cart__heading">Carrito de compras</h1>

          {cartItems.length === 0 ? (
            <div className="hadacy-cart-empty">
              <i className="fas fa-shopping-bag"></i>
              <h3>Tu carrito está vacío</h3>
              <p>Descubre nuestros perfumes y cosméticos.</p>
              <Link to="/" className="hadacy-cart-empty__cta">
                Ir a la tienda
              </Link>
            </div>
          ) : (
            <>
              <div className="hadacy-cart-list">
                {cartItems.map((item) => {
                  const generoMap = {
                    dama: "DAMA",
                    caballero: "CABALLERO",
                    unisex: "UNISEX",
                  };
                  const kickerParts = [];
                  if (item.tipo === "perfumes" && item.genero)
                    kickerParts.push(generoMap[item.genero] || "");
                  if (item.profile)
                    kickerParts.push(item.profile.toUpperCase());
                  const kicker = kickerParts.filter(Boolean).join(" · ");

                  return (
                    <div className="hadacy-cart-row" key={item.product}>
                      <Link
                        to={`/product/${item.product}`}
                        className="hadacy-cart-row__img"
                      >
                        <Image src={item.image} alt={item.name} fluid />
                      </Link>

                      <div className="hadacy-cart-row__info">
                        {kicker && (
                          <div className="hadacy-cart-row__kicker">
                            {kicker}
                          </div>
                        )}
                        <Link
                          to={`/product/${item.product}`}
                          className="hadacy-cart-row__name"
                        >
                          {item.name}
                        </Link>
                        {item.inspo && (
                          <div className="hadacy-cart-row__inspo">
                            inspirado en {item.inspo}
                            {item.volume ? ` · ${item.volume}` : ""}
                          </div>
                        )}
                      </div>

                      <div className="hadacy-cart-row__price">
                        ${item.price}
                      </div>

                      <Form.Select
                        className="hadacy-cart-row__qty"
                        value={item.qty}
                        onChange={(e) => {
                          dispatch(
                            addToCart(item.product, Number(e.target.value))
                          );
                        }}
                        aria-label="Cantidad"
                      >
                        {[...Array(item.countInStock).keys()].map((x) => (
                          <option key={x + 1} value={x + 1}>
                            {x + 1}
                          </option>
                        ))}
                      </Form.Select>

                      <button
                        type="button"
                        className="hadacy-cart-row__remove"
                        onClick={() => removeFromCartHandler(item.product)}
                        aria-label="Eliminar producto"
                        title="Eliminar"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  );
                })}
              </div>

              <Link to="/" className="hadacy-cart-continue">
                <i className="fas fa-arrow-left"></i>
                Seguir comprando
              </Link>
            </>
          )}
        </Col>

        <Col md={4}>
          <aside className="hadacy-cart-summary">
            <h2 className="hadacy-cart-summary__title">Resumen</h2>
            <span className="hadacy-cart-summary__count">
              {totalQty} {totalQty === 1 ? "producto" : "productos"}
            </span>

            <div className="hadacy-cart-summary__rule"></div>

            <div className="hadacy-cart-summary__row">
              <span>Subtotal</span>
              <span>${totalPrice}</span>
            </div>
            <div className="hadacy-cart-summary__row">
              <span>Envío</span>
              <span style={{ fontStyle: "italic", color: "var(--muted)" }}>
                Calculado al pagar
              </span>
            </div>

            <div className="hadacy-cart-summary__rule"></div>

            <div className="hadacy-cart-summary__total">
              <span className="hcs-label">Total</span>
              <span className="hcs-amount">${totalPrice}</span>
            </div>

            {userInfo ? (
              totalQty <= 10 ? (
                <button
                  type="button"
                  className="hadacy-cart-summary__cta"
                  disabled={cartItems.length === 0}
                  onClick={checkoutHandler}
                >
                  Finalizar compra
                  <i className="fas fa-arrow-right"></i>
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="hadacy-cart-summary__cta"
                    disabled
                  >
                    Finalizar compra
                  </button>
                  <p className="hadacy-cart-summary__hint hadacy-cart-summary__hint--warn">
                    No puedes comprar más de 10 productos por pedido.
                  </p>
                </>
              )
            ) : (
              <>
                <button
                  type="button"
                  className="hadacy-cart-summary__cta"
                  disabled={cartItems.length === 0}
                  onClick={LoginHandler}
                >
                  Iniciar sesión
                  <i className="fas fa-arrow-right"></i>
                </button>
                <p className="hadacy-cart-summary__hint">
                  Inicia sesión para finalizar tu compra.
                </p>
              </>
            )}
          </aside>
        </Col>
      </Row>
    </div>
  );
};

export default CartScreen;
